__turbopack_context__.v({
  "allDoneDashboardImage": "AllDoneDashboard-module__kwMegG__allDoneDashboardImage",
});
